import {Component, OnDestroy, OnInit, Signal} from '@angular/core';
import {ApplicationAppEntityApplicationRead, ServiceAppEntityServiceRead} from '../../../openapi';
import {selectApplication, selectLoading, selectPending} from '../../../store/selectors/application.selectors';
import {selectServiceByUrl} from '../../../store/selectors/app.selectors';
import {Store} from '@ngrx/store';
import {ActivatedRoute, RouterModule} from '@angular/router';
import {UploaderAttachmentsService} from '../../../services/uploader-attachments.service';
import {
  loadApplication,
  loadPayments,
  loadRoadOccupationTypes,
  loadServiceAttachmentPositions,
  setApplication,
  setPayments,
  setShipments
} from '../../../store/actions/application.actions';
import {ContentComponent} from '../../../components/content/content.component';
import {BreadcrumbsComponent} from '../../../common/breadcrumbs/breadcrumbs.component';
import {CommonModule} from '@angular/common';
import {SpinnerComponent} from '../../../common/spinner/spinner.component';
import {
  CarryingOutWorksPreviewComponent
} from '../application/carrying-out-works-application/carrying-out-works-preview/carrying-out-works-preview.component';
import {PdfGeneratorService} from '../../../services/pdf.generator.service';
import {AlertContainerComponent, AlertService} from '../../../common/alert-container/alert-container.component';
import {
  LocationReconstructionOfExitPreviewComponent
} from '../application/location-reconstruction-of-exit-application/location-reconstruction-of-exit-preview/location-reconstruction-of-exit-preview.component';
import {
  NotificationOfEmergencyOccupationPreviewComponent
} from '../application/notification-of-emergency-occupation-application/notification-of-emergency-occupation-preview/notification-of-emergency-occupation-preview.component';
import {
  ApprovalOfTheExitDesignPreviewComponent
} from '../application/approval-of-the-exit-design/approval-of-the-exit-design-preview/approval-of-the-exit-design-preview.component';
import {
  LocationOfDevicesUnrelatedToRoadPreviewComponent
} from '../application/location-of-devices-unrelated-to-road/location-of-devices-unrelated-to-road-preview/location-of-devices-unrelated-to-road-preview.component';
import {
  LocalisationDevicesUnrelatedToRoadPreviewComponent
} from '../application/localisation-devices-unrelated-to-road/localisation-devices-unrelated-to-road-preview/localisation-devices-unrelated-to-road-preview.component';
import {
  ApprovalOfTrafficOrganizationProjectsPreviewComponent
} from '../application/approval-of-traffic-organization-projects/approval-of-traffic-organization-projects-preview/approval-of-traffic-organization-projects-preview.component';
import {
  OpinionOnTheProjectOfTrafficOrgPreviewComponent
} from '../application/opinion-on-the-project-of-traffic-org/opinion-on-the-project-of-traffic-org-preview/opinion-on-the-project-of-traffic-org-preview.component';
import {
  PlacementAdvertisingPreviewComponent
} from '../application/placement-advertising/placement-advertising-preview/placement-advertising-preview.component';
import {
  CompensationForLossesPreviewComponent
} from '../application/compensation-for-losses/compensation-for-losses-preview/compensation-for-losses-preview.component';
import {
  OpinionOnIssuingADecisionPreviewComponent
} from '../application/opinion-on-issuing-a-decision/opinion-on-issuing-a-decision-preview/opinion-on-issuing-a-decision-preview.component';
import {
  PublicInformationDisclosurePreviewComponent
} from '../application/public-information-disclosure/public-information-disclosure-preview/public-information-disclosure-preview.component';
import {
  NotificationGeneralRemarksRoadMarkingPreviewComponent
} from '../application/notification-general-remarks-road-marking/notification-general-remarks-road-marking-preview/notification-general-remarks-road-marking-preview.component';
import {
  DocumentsInformationPreviewComponent
} from '../application/documents-information/documents-information-preview/documents-information-preview.component';
import {
  GeneralLetterPreviewComponent
} from '../application/general-letter/general-letter-preview/general-letter-preview.component';
import {
  ResponseToCallPreviewComponent
} from '../application/response-to-call/response-to-call-preview/response-to-call-preview.component';
import {
  OccupationDataOfLanePlacementConstructionObjectsPreviewComponent
} from '../application/occupation-of-lane-placement-construction-objects/occupation-data-of-lane-placement-construction-objects-preview/occupation-data-of-lane-placement-construction-objects-preview.component';
import {LabelComponent} from '../../../common/label/label.component';
import {
  WithdrawalOfTheApplicationPreviewComponent
} from '../application/withdrawal-of-the-application/withdrawal-of-the-application-preview/withdrawal-of-the-application-preview.component';
import {
  CancellationOfTheApplicationPreviewComponent
} from '../application/cancellation-of-the-application/cancellation-of-the-application-preview/cancellation-of-the-application-preview.component';
import {
  ComplaintOfTheApplicationPreviewComponent
} from '../application/complaint-of-the-application/complaint-of-the-application-preview/complaint-of-the-application-preview.component';
import {
  PermitForOversizeVehiclesPreviewComponent
} from "../application/permit-for-oversize-vehicles/permit-for-oversize-vehicles-preview/permit-for-oversize-vehicles-preview.component";
import {
  AccessToPublicRoadPreviewComponent
} from "../application/access-to-public-road/access-to-public-road-preview/access-to-public-road-preview.component";

@Component({
  selector: 'app-sent-preview-page',
  standalone: true,
  imports: [
    ContentComponent,
    BreadcrumbsComponent,
    RouterModule,
    CommonModule,
    SpinnerComponent,
    CarryingOutWorksPreviewComponent,
    AlertContainerComponent,
    LocationReconstructionOfExitPreviewComponent,
    NotificationOfEmergencyOccupationPreviewComponent,
    ApprovalOfTheExitDesignPreviewComponent,
    LocationOfDevicesUnrelatedToRoadPreviewComponent,
    LocalisationDevicesUnrelatedToRoadPreviewComponent,
    ApprovalOfTrafficOrganizationProjectsPreviewComponent,
    OpinionOnTheProjectOfTrafficOrgPreviewComponent,
    PlacementAdvertisingPreviewComponent,
    CompensationForLossesPreviewComponent,
    OpinionOnIssuingADecisionPreviewComponent,
    PublicInformationDisclosurePreviewComponent,
    NotificationGeneralRemarksRoadMarkingPreviewComponent,
    DocumentsInformationPreviewComponent,
    GeneralLetterPreviewComponent,
    ResponseToCallPreviewComponent,
    OccupationDataOfLanePlacementConstructionObjectsPreviewComponent,
    LabelComponent,
    WithdrawalOfTheApplicationPreviewComponent,
    CancellationOfTheApplicationPreviewComponent,
    ComplaintOfTheApplicationPreviewComponent,
    PermitForOversizeVehiclesPreviewComponent,
    AccessToPublicRoadPreviewComponent
  ],
  providers: [UploaderAttachmentsService, PdfGeneratorService],
  templateUrl: './sent-preview-page.component.html'
})
export class SentPreviewPageComponent implements OnInit, OnDestroy {
  public applicationId: string | undefined =
    this.route.snapshot.params['appId'];

  public application: Signal<ApplicationAppEntityApplicationRead | null> =
    this.store$.selectSignal(selectApplication);

  public contentUrl: string | undefined = this.route.snapshot.params['contentUrl'];

  public serviceType: Signal<ServiceAppEntityServiceRead | null> =
    this.store$.selectSignal(
      selectServiceByUrl(this.contentUrl || '')
    );

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  constructor(
    private store$: Store,
    private route: ActivatedRoute,
    private uploaderService: UploaderAttachmentsService,
    private pdfGeneratorService: PdfGeneratorService,
    private alertService: AlertService
  ) {
  }

  public onDownloadApplicationPdf(event: Event): void {
    const id = this.application()?.document?.id;
    const name = this.application()?.document?.originalName;
    event.preventDefault();
    event.stopPropagation();
    if (id && name) {
      this.uploaderService.downloadAttachment(id, name).toPromise().then();
    }
  }

  public onDownloadUPP(event: Event): void {
    const id = this.application()?.epuapUppAttachment?.id;
    const name = this.application()?.epuapUppAttachment?.originalName;
    event.preventDefault();
    event.stopPropagation();
    if (id && name) {
      this.uploaderService.downloadAttachment(id, name).toPromise().then();
    }
  }

  public onDownloadUPO(event: Event): void {
    const id = this.application()?.uuid;
    event.preventDefault();
    event.stopPropagation();
    if (id) {
      this.pdfGeneratorService.generateUPOPdf(id).toPromise().then();
    }
  }

  public ngOnInit(): void {
    this.alertService.showByApplicationCode(history.state?.message);

    this.store$.dispatch(loadApplication({id: this.applicationId || ''}));
    this.store$.dispatch(loadPayments({applicationId: this.applicationId || ''}));
    this.store$.dispatch(loadRoadOccupationTypes());
    this.store$.dispatch(loadServiceAttachmentPositions({appId: this.applicationId || ''}));
  }

  public ngOnDestroy(): void {
    this.store$.dispatch(setApplication({application: null}));
    this.store$.dispatch(setPayments({applicationPayment: null}));
    this.store$.dispatch(setShipments({shipments: []}));
  }
}
